import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Constants
import { availableLanguages } from "../../../../i18n";
import useOverlayClose from "../../../../config/useOverlayClose";
// Components
import {
  SelectorBar,
  SelectorInner,
  SelectorButton,
  Flag,
  Overlay,
  Modal,
  ModalHeader,
  ModalTitle,
  CloseButton,
  CloseIcon,
  LanguageOption,
  RadioIcon,
} from "./styles";
// Assets
import { cross, radioButtonEmpty, radioButtonFull, languageFlags } from "../../../../assets/icons";

const LanguageSelector = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const overlayHandlers = useOverlayClose(() => setIsModalOpen(false));

  const selectLanguage = (language) => {
    i18n.changeLanguage(language);
    setIsModalOpen(false);
  };

  const renderModal = () => {
    return (
      <Overlay {...overlayHandlers}>
        <Modal>
          <ModalHeader>
            <ModalTitle>{t("budget.chooseLanguage")}</ModalTitle>
            <CloseButton type="button" onClick={() => setIsModalOpen(false)} aria-label={t("budget.close")}>
              <CloseIcon src={cross} alt="" />
            </CloseButton>
          </ModalHeader>
          {availableLanguages.map((language) => {
            const isSelected = language === currentLanguage;
            return (
              <LanguageOption key={language} type="button" $isSelected={isSelected} onClick={() => selectLanguage(language)}>
                <RadioIcon src={isSelected ? radioButtonFull : radioButtonEmpty} alt="" />
                <Flag src={languageFlags[language]} alt="" />
                {t(`language.${language}`)}
              </LanguageOption>
            );
          })}
        </Modal>
      </Overlay>
    );
  };

  return (
    <SelectorBar>
      <SelectorInner>
        <SelectorButton type="button" onClick={() => setIsModalOpen(true)}>
          <Flag src={languageFlags[currentLanguage]} alt="" />
          {t(`language.${currentLanguage}`)}
        </SelectorButton>
      </SelectorInner>
      {isModalOpen && renderModal()}
    </SelectorBar>
  );
};

export default LanguageSelector;
